<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height class="login-app">
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-card-title class="text-center">Efetuando login</v-card-title>

              <v-card-text>
                <v-progress-linear :indeterminate="true"></v-progress-linear>
              </v-card-text>
            </v-card>

          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-snackbar
      v-model="showAlert"
      :top="true"
      :color="colorAlert"
    >
      {{ textAlert }}
    </v-snackbar>

  </v-app>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'LoginPortal',

  computed: {
    token: function () {
      return this.$route.params.token
    }
  },

  data () {
    return {
      showAlert: false,
      colorAlert: '',
      textAlert: ''
    }
  },

  methods: {
    ...mapActions(['setToken', 'setUser', 'setUserPermissions']),

    setUserData (returnUserData) {
      this.setToken(returnUserData.token)
      this.setUser({ name: returnUserData.name, id: returnUserData._id })

      this.setUserPermissions(returnUserData.permission)
    },

    doLogin (token) {
      this.axios.request({
        method: 'get',
        url: '/user/login/portal',
        data: { token: this.$route.params.token },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).then(({ data }) => {
        if (data.user) {
          this.setUserData(data.user)
        }

        setTimeout(() => {
          this.$router.push({ name: 'home' })
        }, 2000)
      }).catch(err => {
        console.error(err)

        this.showAlert = true
        this.colorAlert = 'error'
        this.textAlert = 'Erro ao logar'
      })
    }
  },

  created () {
    this.doLogin(this.token)
  }
}
</script>

<style scoped>

</style>
